import React from "react";
import {
  auPhNumber,
  auText,
  invcsConnect,
  mail,
  nzPhNumber,
  nzText
} from "../../locales/en";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  MAILTO_INFO_EMAIL,
  PHONE_NO_AU,
  PHONE_NO_NZ
} from "../../utils/constants/appConstants";

const AccountingSoftwareContact = () => {
  return (
    <>
      <div className="setup-section">
        <h3>{invcsConnect?.unSure}</h3>
        <p>{invcsConnect?.chatToOur}</p>

        <ul className="contact-section">
          <li>
            <span className="icon">
              <FaEnvelope />
            </span>
            <span>
              <Link to={MAILTO_INFO_EMAIL}>{mail}</Link>
            </span>
          </li>
          <li>
            <span className="icon">
              <FaPhoneAlt />
            </span>
            <span>
              <p>
                {auText}
                <Link to={PHONE_NO_AU}>{auPhNumber}</Link>
              </p>
              <p>
                {nzText}
                <Link to={PHONE_NO_NZ}>{nzPhNumber}</Link>
              </p>
            </span>
          </li>
        </ul>
      </div>

      <div className="privecy-text-wrap text-center">
        <p>{invcsConnect?.wetakeUour}</p>
      </div>
    </>
  );
};

export default AccountingSoftwareContact;
